import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M16.667 6.667a6.667 6.667 0 1 0 0 13.334 6.667 6.667 0 0 0 0-13.334M28.333 20a.43.43 0 0 0-.433.35l-.317 2.2c-.5.217-.983.483-1.416.783L24.1 22.5c-.183 0-.4 0-.517.217L21.917 25.6c-.1.183-.067.4.1.533l1.766 1.367a7 7 0 0 0 0 1.667l-1.766 1.366a.43.43 0 0 0-.1.534l1.666 2.883c.1.217.317.217.517.217l2.067-.834c.433.3.9.584 1.416.784l.317 2.2c.033.2.2.35.433.35h3.334c.183 0 .366-.15.4-.35l.316-2.2c.5-.217.95-.484 1.4-.784l2.05.834c.217 0 .434 0 .55-.217l1.667-2.883a.434.434 0 0 0-.1-.534l-1.783-1.366c.033-.284.066-.55.066-.834s-.016-.55-.066-.833l1.766-1.367a.43.43 0 0 0 .1-.533l-1.666-2.883c-.1-.217-.317-.217-.534-.217l-2.05.833c-.45-.3-.9-.583-1.416-.783l-.317-2.2a.394.394 0 0 0-.383-.35zm-11.666 3.333C9.3 23.333 3.333 26.317 3.333 30v3.333h16.134a11.7 11.7 0 0 1-1.134-5 11.7 11.7 0 0 1 1.067-4.85c-.883-.1-1.8-.15-2.733-.15M30 25.833c1.383 0 2.5 1.117 2.5 2.5s-1.117 2.5-2.5 2.5c-1.4 0-2.5-1.116-2.5-2.5s1.117-2.5 2.5-2.5"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }